module.exports = __webpack_public_path__ + "static/img/banner090501-2.8f611ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner090501-2.jpg
// module id = 8n4N
// module chunks = 4